@if (dynamicMinDate$ | async) {
  <ng-container [formGroup]="form">
    <div class="row">
      <div attr.class="row_date {{ colClass }}">
        <mat-form-field appearance="fill" class="date-input-box">
          @if (!dateControl.value || showLabelAfterInput) {
            <mat-label>{{ label }}</mat-label>
          }
          <div style="display: flex">
            <input
              matInput
              [attr.data-cy]="datacy"
              [errorStateMatcher]="errorState"
              ngbDatepicker
              [container]="datepickerContainer"
              class="filter-calendar"
              autocomplete="off"
              #d="ngbDatepicker"
              [displayMonths]="displayMonths || 2"
              navigation="arrows"
              outsideDays="visible"
              [firstDayOfWeek]="0"
              [maxLength]="10"
              appDateMask
              [minDate]="ngbMinDate"
              [maxDate]="ngbMaxDate"
              (dateSelect)="onDateChange($event)"
              (change)="onDateChange($event)"
              (keyup)="onDateChange($event)"
            />
            <button class="date-icon" data-cy="date-icon" (click)="d.toggle()" type="button">
              <i class="icon-date-range" aria-hidden="true"></i>
            </button>
          </div>
        </mat-form-field>
        @for (errorTypes of errorTypes$ | async; track errorTypes; let i = $index) {
          <mat-error data-cy="date-error"> <i class="icon-warning_white"></i> {{ errorTextObj[errorTypes] }} </mat-error>
        }
      </div>
    </div>
  </ng-container>
}
